<template>
  <div id="map" ref="mapRef" class="map-container"></div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch, createApp, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import StoreInfo from "@/components/LocallUs/StoreInfo.vue";

const router = useRouter();
const { locale } = useI18n();
const runtimeConfig = useRuntimeConfig();
const mapRef = ref(null);
const searchQuery = ref('');
const emit = defineEmits(['setValueText',"handleFilterBylatLng"]);
const mapStyle = [
  {
    featureType: "all",
    elementType: "labels.text.fill",

  },
  {
    featureType: "all",
    elementType: "labels.text.stroke",

  },
  {
    featureType: "all",
    elementType: "labels.icon",

  },
  {
    featureType: "administrative",
    elementType: "geometry.fill",

  },
  {
    featureType: "administrative",
    elementType: "geometry.stroke",
  },
  {
    featureType: "landscape",
    elementType: "geometry",

  },
  {
    featureType: "poi",
    elementType: "geometry",
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
  },
  {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [
      { color: "#cfcece" },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [
      { color: "#cfcece" },
    ],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry",

  },
  {
    featureType: "road.local",
    elementType: "geometry",

  },
  {
    featureType: "transit",
    elementType: "geometry",

  },
  {
    featureType: "water",
    elementType: "geometry",


  },
  {
    featureType: "poi.business",
    elementType: "labels.text.fill",
    stylers: [
      { visibility: "on" },
      { color: "#1d1d1d" },
      { lightness: 15 }
    ]
  },
  {
    featureType: "road",
    elementType: "labels",

  },
  {
    featureType: "poi",
    elementType: "labels.text",
  }
];
const defaultCenter = { lat: 3.1390, lng: 101.6869 };

const querySearch = ref({
  query: '',
  location: {
    // lat: 1.3521,
    // lng: 103.8198
    lat: 3.1390,
    lng: 101.6869
  },
  radius: 20000
});

const props = defineProps({
  textSerch: String,
  dataStore: Array,
  position: Object,
  ClickAction: Number,
  positionSlug: Object,
  isNull: Boolean
});

watch(() => props.isNull, (newVal) => {
  // console.log('isNull', newVal);
  if (newVal) {
    handleLoadMap();

  }
});

const searchLocation = (newVal) => {
  if (!newVal) return;

//   const singaporeCenter = { lat: 1.3521, lng: 103.8198 };
//   const singaporeBounds = {
//     north: 1.47128,
//     south: 1.13047,
//     east: 104.1231,
//     west: 103.609,
//   };

//   const service = new window.google.maps.places.PlacesService(window.map);

//   service.textSearch({
//     query: newVal,
//     location: singaporeCenter,
//     radius: 20000
//   }, (results, status) => {
//     if (status === window.google.maps.places.PlacesServiceStatus.OK && results.length > 0) {
//       const location = results[0].geometry.location;
//       const lat = location.lat();
//       const lng = location.lng();
//       emit('handleFilterBylatLng', { lat, lng });

//       if (lat >= singaporeBounds.south && lat <= singaporeBounds.north &&
//           lng >= singaporeBounds.west && lng <= singaporeBounds.east) {
//         console.log(results[0].geometry.location.lat);
//         const latitude = results[0].geometry.location.lat();
// const longitude = results[0].geometry.location.lng();

// console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);
//         emit('setValueText', results[0].formatted_address);
//         window.map.setCenter(location);
//         window.map.setZoom(14);
//       } else {
//         emit('setValueText', results[0].formatted_address);
//         console.log("Vị trí tìm kiếm không nằm trong Singapore. Hoạt động bị hủy.");
//       }
//     } else {
//       console.error('Places search failed with status:', status);
//     }
//   });
};

const handleClickPosition = () => {
  if (!props.position) return;

  if (!window.map) {
    console.error("Google Map is not initialized yet.");
    return;
  }
  try {
    const service = new window.google.maps.places.PlacesService(window.map);
    window.map.setCenter({ lat: props.position.lat, lng: props.position.lng });
    window.map.setZoom(15);

  } catch (error) {
    console.error("Error setting the map position:", error);
  }
};


const handleLoadMap = async () => {
  return new Promise((resolve) => {
    if (typeof window.google !== 'undefined') {
      resolve(window.google);
    } else {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${runtimeConfig.public.API_MAP_KEY}&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        resolve(window.google);
      };
      document.head.appendChild(script);
    }
  });

};

const loadGoogleMaps = async () => {
  const google = await handleLoadMap();

  if (!mapRef.value) {
    console.error("mapRef.value is null. Ensure the element exists.");
    return;
  }
  const isMobile = window.innerWidth <= 768;
  const zoomLevel = isMobile ? 10 : 12;
  const mapOptions = {
    center: props.positionSlug ?? defaultCenter,
    zoom: zoomLevel,
    styles: mapStyle,
  };
  const map = new google.maps.Map(mapRef.value, mapOptions);
  window.map = map;
  let currentInfoWindow: any = null;
  
  if (!props.dataStore) return;
  props.dataStore.forEach(location => {
    const marker = new google.maps.Marker({
      position: { lat: parseFloat(location.lat), lng: parseFloat(location.lng) },
      map: map,
      title: location.title,
    });

    marker.addListener('click', () => {
      // Close previous infoWindow
      if (currentInfoWindow) {
        currentInfoWindow.close();
      }
      
      // Create new infoWindow for this marker
      const infoWindow = new google.maps.InfoWindow();
      const container = document.createElement('div');
      
      // Create HTML content with original styles
      container.innerHTML = `
        <div class="store-item" style="
          font-family: 'Roboto', sans-serif !important;
          padding: 10px 20px;
          margin-bottom: 15px;
        ">
          <p class="popup-store-name" style="
            margin: 0;
            margin-bottom: 16px;
            color: #AD073D;
            font-size: 17px;
            letter-spacing: 1.3px;
            font-weight: 400;
            font-family: 'Roboto', sans-serif !important;
            cursor: pointer;
          ">${location.name}</p>
          
          <div class="store-address" style="
            font-size: 14px;
            color: #88888d;
            margin-bottom: 16px;
          ">${location.content || ''}</div>
          
          ${location.link ? `<a href="${location.link.url}" target="_blank" rel="noopener" class="get-directions" style="
            background-color: transparent;
            border: none;
            color: black;
            font-size: 13px;
            cursor: pointer;
            display: flex;
            align-items: center;
            padding: 0;
            margin-top: 0.5rem;
            font-weight: 400;
            text-decoration: none;
            outline: 0;
          ">
            Get Directions <span data-v-dbb9fde8="" class="arrows"><svg data-v-dbb9fde8="" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" style="margin: 1px 4px -3px 6px;"><path data-v-dbb9fde8="" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m9 5l7 7l-7 7"></path></svg></span>
          </a>` : ''}
        </div>
      `;
      
      // Add click handler to store name
      const storeNameEl = container.querySelector('.popup-store-name');
      if (storeNameEl) {
        storeNameEl.addEventListener('click', () => {
          if (locale.value === 'ms-my') {
            router.push(`/ms-my/locate-us/${location.slug}/`);
          } else {
            router.push(`/locate-us/${location.slug}/`);
          }
        });
      }
      
      infoWindow.setContent(container);
      infoWindow.open(map, marker);
      currentInfoWindow = infoWindow;
    });
  });
};

onMounted(async () => {
  await nextTick();
  await loadGoogleMaps();
});

watch(() => props.dataStore, (newVal) => {
  if (newVal) {
    loadGoogleMaps();
  }
}, { immediate: true, deep: true });

watch(() => props.textSerch, (newVal) => {
  if (newVal && newVal.trim()) {
    searchQuery.value = newVal;
    searchLocation(newVal);
  } else {
    console.warn('Search query is empty');
  }
}, { immediate: true });
watch(() => props.ClickAction, (newVal) => {
  if (newVal && props.position) {
    handleClickPosition();
  } else {
    console.warn('Search query is empty or position is not set');
  }
}, { immediate: true });

</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/locate-us/_store-info.scss";
.map-container {
  width: 100%;
  min-height: 751px;
    position: relative;
    overflow: hidden;
    height: 100%;
  @media screen and (max-width: 768px) {
    min-height: 400px;
  }
  @media screen and (max-width: 460px) {
    min-height: 350px;
  }
}
</style>